import {
  AlertsContainer,
  Header,
  VerticalListing,
  useTranslation
} from '@fareye/common'
import { IKeyValueObj } from '@fareye/types'
import { Flex, IRenderControl, RenderControl } from '@fareye/ui'
import { currenthhmmA, isEmpty } from '@fareye/utils'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { IPageConfig, TAlertChildrenConfig } from '../../../utility/types'
import { SubscriptionListing } from '../../AlertSettings/SubscriptionListing'
import { AlertReportListing } from './AlertReportListing'

interface IAlertSettingProps extends RouteComponentProps {
  routesConfig: any
  config: IPageConfig
  subType: string
  baseUrl:any
}

export function AlertReport({
  match,
  history,
  location,
  routesConfig,
  config: propConfig,
  subType,
  baseUrl
}: IAlertSettingProps) {
  const { t } = useTranslation()
  const { styling, children, config } = propConfig
  const { showTimezone = false } = config
  const { bodyBgColor } = styling ? styling : { bodyBgColor: '' }
  const [selectedAlertType, setSelectedAlertType] = React.useState<string>(
    (config
      ? config.selectedAlertType
      : 'DisconnectionAlertSubscription') as string
  )

  const [lastUpdate, setLastUpdate] = React.useState(currenthhmmA())
  const [selectedAlert, setSelectedAlert] = React.useState(null)
  const [alertConfig, setAlertConfig] = React.useState<IRenderControl>({
    data: config.alertListing,
    isLoading: false,
    isSuccess: true,
    message: '',
    isError: false
  })
  let tempAlertConfig = alertConfig.data
  let listingOptions: Array<IKeyValueObj<string>> = []
  Object.keys(tempAlertConfig).map((ele: string) => {
    listingOptions.push({
      label: tempAlertConfig[ele].formBuilderConfig.label,
      value: ele
    })
  })

  return (
    <Flex column width={1} style={{ height: '100%' }}>
      <Header
        lastUpdate={lastUpdate}
        match={match}
        location={location}
        history={history}
        routesConfig={routesConfig}
        showTimezone={showTimezone}
      />
      <div style={{ flexGrow: 1, background: bodyBgColor, overflow: 'hidden' }}>
        <RenderControl state={alertConfig} variant="l" t={t}>
          <AlertsContainer>
            {!isEmpty(alertConfig.data) && (
              <>
                <VerticalListing
                  listingOptions={listingOptions}
                  setSelected={setSelectedAlertType}
                  selected={selectedAlertType}
                />
                <Flex column style={{ overflow: 'auto', gap: '0.625em' }}>
                  <SubscriptionListing
                    selectedAlert={selectedAlert}
                    setSelectedAlert={setSelectedAlert}
                    subscriptionType={selectedAlertType}
                    alertChildrenConfig={children}
                    isRadio={true}
                    selectAlertLabel={
                      alertConfig.data[selectedAlertType].formBuilderConfig
                        .label
                    }
                  />
                  <AlertReportListing
                    selectedAlert={selectedAlert}
                    selectedColumns={
                      alertConfig.data[selectedAlertType].reportConfig
                        .selectedColumns
                    }
                    reportFilters={
                      alertConfig.data[selectedAlertType]?.reportFilters
                    }
                    subType={subType}
                    selectedAlertType={selectedAlertType}
                    setSelectedAlert={setSelectedAlert}
                    propConfig={children as TAlertChildrenConfig}
                    showTimezone={showTimezone}
                    baseUrl={baseUrl}
                  />
                </Flex>
              </>
            )}
          </AlertsContainer>
        </RenderControl>
      </div>
    </Flex>
  )
}
